export {
  addIdRef,
  asModelRefFromFirestoreRef,
  FirebaseCollectionReferenceModel as CollectionReferenceModel,
  convertModel,
  docChangesToToArray,
  FirebaseDocumentSnapshotModel as DocumentSnapshotModel,
  Filter,
  type FirebaseModelData,
  getBatch,
  getCollection,
  getCollectionGroup,
  getDocsFromNamedQuery,
  firestoreLoadBundle as loadBundle,
  type Model,
  modelArrayRemove,
  modelArrayUnion,
  FirebaseModelWriteBatch as ModelBatch,
  type ModelData,
  modelDeleteField,
  modelDocumentId,
  type ModelFields,
  modelFromPath,
  type ModelId,
  type ModelIdRef,
  modelIncrement,
  type ModelRef,
  FirebaseModelReference as ModelReference,
  modelServerTimestamp,
  modelsSetLogLevel,
  ModelTimestamp,
  type ModelWithDataAndId,
  type ModelWithDataAndRef,
  type ModelWithRefIdAndData,
  firestoreNamedQuery as namedQuery,
  PathError,
  FirebaseQueryDocumentSnapshotModel as QueryDocumentSnapshotModel,
  FirebaseQueryModel as QueryModel,
  FirebaseQuerySnapshotModel as QuerySnapshotModel,
  runTransaction,
  setModelsSingleton,
  TransactionModel,
  type TWhereValue,
  type UpdateFields,
  type WithFirebaseModel,
  type WithModelValue,
} from "./core";
export { addIdealModelsHook, addIdealModelsHookOnce, type OnIdeal } from "./idealHooks";
export { subCollection } from "@doitintl/models-types";
